/*
 * Copyright (c) 2020.
 * This file is part of the Compo B2B application.
 * (c) Compo soft - Vladimir Ganturin <gun2rin@gmail.com>
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */

import {ChangeDetectionStrategy, Component, OnInit} from '@angular/core';
import {DocumentMenu, IdAndHeader} from 'compob2b-libs';
import {map, tap} from 'rxjs/operators';
import {translations} from '../../../../../environments/translations.ru';
import {CreateUpdateComponent} from '../../../../admin-shared/crud-components/create-update/create-update.component';
import {RelatedEntity} from '../../../../admin-shared/interfaces/related.entity';
import {DAM_RELATED_COLLECTION_FORM} from '../dam-related-collection-forms.config';

@Component({
  selector: 'app-dam-create',
  templateUrl: '../../../../admin-shared/crud-components/create-update/create-update.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CreateUpdateDamRelatedCollectionComponent extends CreateUpdateComponent<IdAndHeader> implements OnInit {

  title = translations.collections;
  protected uri = '/dam/dam-related-collection';
  absolutePath = '/cabinet/dam/dam-related-collection';
  protected entity: DocumentMenu;
  allDamRelatedClass: IdAndHeader[];

  ngOnInit() {
    const damRelatedClass = this.compoApiService.get<IdAndHeader[]>(this.uri + '/list-dam-related-class')
      .pipe(map(response => response.data), tap(data => this.allDamRelatedClass = data));

    const relatedEntities: RelatedEntity[] = [{multipleEntity: damRelatedClass, multipleField: 'damRelatedClassId'}];
    this.config = {
      uri: this.uri,
      columns: DAM_RELATED_COLLECTION_FORM,
      title: this.title,
      absolutePath: this.absolutePath,
      relatedEntity: relatedEntities
    };

    super.setConfig(this.config);
    super.ngOnInit();

  }
}
